var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterTwIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1367 9.39319C19.8398 8.86584 20.4727 8.23303 20.9648 7.49475C20.332 7.776 19.5938 7.98694 18.8555 8.05725C19.6289 7.60022 20.1914 6.89709 20.4727 6.01819C19.7695 6.44006 18.9609 6.75647 18.1523 6.93225C17.4492 6.19397 16.5 5.77209 15.4453 5.77209C13.4062 5.77209 11.7539 7.42444 11.7539 9.4635C11.7539 9.74475 11.7891 10.026 11.8594 10.3073C8.80078 10.1315 6.05859 8.65491 4.23047 6.44006C3.91406 6.96741 3.73828 7.60022 3.73828 8.30334C3.73828 9.56897 4.37109 10.694 5.39062 11.3619C4.79297 11.3268 4.19531 11.1862 3.70312 10.9049V10.9401C3.70312 12.733 4.96875 14.2096 6.65625 14.5612C6.375 14.6315 6.02344 14.7018 5.70703 14.7018C5.46094 14.7018 5.25 14.6666 5.00391 14.6315C5.46094 16.108 6.83203 17.1627 8.44922 17.1979C7.18359 18.1823 5.60156 18.7799 3.87891 18.7799C3.5625 18.7799 3.28125 18.7448 3 18.7096C4.61719 19.7643 6.55078 20.3619 8.66016 20.3619C15.4453 20.3619 19.1367 14.7721 19.1367 9.88538C19.1367 9.70959 19.1367 9.56897 19.1367 9.39319Z",
    fill: "#022219"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterTwIcon);
export default __webpack_public_path__ + "static/media/footer_tw_icon.77da3ccd8ec37d1c3f0bc4745e18bbdf.svg";
export { ForwardRef as ReactComponent };